var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('amf-search-box',{attrs:{"label":_vm.label,"placehold":'Search users',"search":_vm.internalSearch,"autofocus":_vm.autofocus,"showResultAfterSelection":_vm.showResultAfterSelection,"showClearButton":_vm.showClearButton},on:{"select":_vm.onSelectUser,"clear":_vm.onClearUser}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb57d648","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/UserSearch.vue
// module id = null
// module chunks = 